@if (currentCurrency$ | async; as currency) {
  <span [innerHTML]="currency"></span>&nbsp;
}
